import Swal from 'sweetalert2';

class CenterHorses {
    // Auto resize
    static autoResize() {
        window.addEventListener('message', function (event) {
            if (event.data && !event.data.vueDetected && event.data.source !== 'vue-devtools-proxy' && event.data.source !== 'vue-devtools-backend') {
                let json = $.parseJSON(event.data);

                if (json.swal) {
                    Swal.fire(json.swal)

                } else if (json.resize && json.resize.height) {
                    let height = json.resize.height;
                    $('.chFrame').attr('height', `${height}px`);
                }
            }
        });

        $(window).scroll(function () {
            document.getElementById('chFrame').contentWindow.postMessage(JSON.stringify({
                'chFrame': document.getElementById('chFrame').getBoundingClientRect().y
            }), '*')
        })
    }
}

window.CenterHorses = CenterHorses;